export type NotificationStatusKeys = keyof typeof notificationStatus
export const notificationStatus = [
    {
        value: '1',
        label: 'Nova'
    },
    {
        value: '2',
        label: 'Aguardando'
    },
    {
        value: '3',
        label: 'Em Tratamento'
    },
    {
        value: '4',
        label: 'Pendente Finalização'
    },
    {
        value: '5',
        label: 'Finalizada'
    },
    {
        value: '6',
        label: 'Arquivada'
    }
]
